<section class="customPrints w-full max-w-4xl mx-auto px-3 md:px-6 py-6 space-y-6" dir="rtl">

  <header class="flex flex-col gap-1">
    <p class="text-base text-ink-500">מתפללים</p>
    <h1 class="text-3xl font-bold text-primary-700">{{ header }}</h1>
  </header>

  <!-- Action cards -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
    <button
      *ngFor="let label of actions"
      type="button"
      (click)="onButtonClick(label)"
      class="card-2026 flex flex-row items-center gap-4 group hover:bg-accent-50 transition-colors min-h-tap text-right"
    >
      <span class="flex items-center justify-center w-12 h-12 rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-colors">
        <i class="material-symbols-outlined text-2xl" aria-hidden="true">{{ label.icon }}</i>
      </span>
      <span class="text-lg font-semibold text-ink-800">{{ label.txt }}</span>
    </button>
  </div>

  <!-- Dialog overlay -->
  <div
    *ngIf="showDialog"
    class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
    (click)="closeDialog()"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="bg-surface rounded-2xl shadow-elevated w-full max-w-4xl max-h-[95vh] flex flex-col overflow-hidden"
      (click)="$event.stopPropagation()"
    >
      <!-- Dialog header -->
      <div class="px-4 md:px-6 py-4 bg-primary-500 text-white flex justify-between items-center gap-3">
        <h2 class="text-lg md:text-xl font-bold">
          {{ dialogMode === 'history' ? 'היסטוריה' : 'הזנה ידנית' }}
        </h2>
        <div class="flex gap-2">
          <button
            type="button"
            (click)="switchMode('normal')"
            class="px-3 py-1.5 text-sm rounded-lg border border-white/30 transition-all"
            [class.bg-accent-500]="dialogMode === 'normal'"
            [class.border-accent-500]="dialogMode === 'normal'"
          >
            רגיל
          </button>
          <button
            type="button"
            (click)="switchMode('history')"
            class="px-3 py-1.5 text-sm rounded-lg border border-white/30 transition-all"
            [class.bg-accent-500]="dialogMode === 'history'"
            [class.border-accent-500]="dialogMode === 'history'"
          >
            היסטוריה
          </button>
        </div>
      </div>

      <!-- Dialog body -->
      <div class="flex-1 overflow-y-auto px-4 md:px-6 py-5">

        <!-- History mode — compact picker, centered inside wide dialog -->
        <div *ngIf="dialogMode === 'history'" class="flex flex-col gap-3 max-w-md mx-auto">
          <div class="form-row-2026">
            <label class="form-row-2026__label" for="prtYear">שנה</label>
            <select id="prtYear" [(ngModel)]="selectedYear" class="input-2026">
              <option *ngFor="let y of yearList" [value]="y">{{ y }}</option>
            </select>
          </div>

          <div class="form-row-2026">
            <label class="form-row-2026__label" for="prtSearch">חיפוש פרשה</label>
            <input
              id="prtSearch"
              type="text"
              placeholder="הקלד שם פרשה..."
              (input)="onSearchTermChange($event)"
              class="input-2026"
            />
          </div>

          <div class="max-h-72 overflow-y-auto border border-ink-100 rounded-lg divide-y divide-ink-100">
            <button
              *ngFor="let p of filteredParashaList"
              type="button"
              (click)="selectedParasha = p"
              class="w-full text-right px-3 py-2.5 text-base hover:bg-bg transition-colors min-h-tap"
              [class.bg-primary-100]="selectedParasha === p"
              [class.font-semibold]="selectedParasha === p"
            >
              {{ p }}
            </button>
          </div>
        </div>

        <!-- Manual mode — book up top, then two columns: hazanim | aliyot.
             All name pickers are <select> dropdowns of users (by full name)
             so admins can only pick a real user, not free-type a name. The
             only free-text field is "הפטרה". A single users$|async sub
             feeds every <select> below. -->
        <div *ngIf="dialogMode === 'normal'" class="flex flex-col gap-4">

          <!-- Book selector — full width -->
          <div class="form-row-2026">
            <label class="form-row-2026__label" for="prtBook">ספר</label>
            <select id="prtBook" [(ngModel)]="selectedBook" class="input-2026">
              <option [ngValue]="null">--- בחר ספר ---</option>
              <option *ngFor="let b of bookList" [value]="b">{{ b }}</option>
            </select>
          </div>

          <ng-container *ngIf="users$ | async as users">
            <!-- Two columns on md+: hazanim (left) / aliyot+ptihat+haftara (right) -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">

              <!-- Hazanim override -->
              <div class="bg-bg p-4 rounded-xl space-y-3 border border-ink-100 self-start">
                <p class="text-sm font-semibold border-b border-ink-100 pb-2 text-ink-600">
                  חזנים
                </p>
                <p class="text-xs text-ink-500 leading-relaxed">
                  אופציונלי. מילוי שדה אחד או יותר יציג בטופס המודפס רק את השמות שהוזנו (לפי הסדר, ללא השדות הריקים). אם כל השדות ריקים, יוצגו ברירות המחדל של המערכת.
                </p>

                <div class="form-row-2026" *ngFor="let label of hazanimLabels; let i = index">
                  <label class="form-row-2026__label" [attr.for]="'prtHazan' + i">{{ label }}</label>
                  <select
                    [id]="'prtHazan' + i"
                    [(ngModel)]="manualHazanim[i]"
                    class="input-2026"
                  >
                    <option value="">-- בחר מתפלל --</option>
                    <option *ngFor="let u of users" [value]="u.firstName + ' ' + u.lastName">
                      {{ u.firstName }} {{ u.lastName }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Ptihat heihal + haftara + aliyot names -->
              <div class="bg-bg p-4 rounded-xl space-y-3 border border-ink-100">
                <p class="text-sm font-semibold border-b border-ink-100 pb-2 text-ink-600">
                  שמות לעליות וכיבודים
                </p>

                <!-- Ptihat (select) + haftara (free text) side by side on sm+ -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div class="form-row-2026">
                    <label class="form-row-2026__label" for="prtPtihat">פתיחת היכל</label>
                    <select
                      id="prtPtihat"
                      [(ngModel)]="manualPtihatHihal"
                      class="input-2026"
                    >
                      <option value="">-- בחר מתפלל --</option>
                      <option *ngFor="let u of users" [value]="u.firstName + ' ' + u.lastName">
                        {{ u.firstName }} {{ u.lastName }}
                      </option>
                    </select>
                  </div>

                  <div class="form-row-2026">
                    <label class="form-row-2026__label" for="prtHaftara">הפטרה</label>
                    <input
                      id="prtHaftara"
                      type="text"
                      [(ngModel)]="manualHaftara"
                      class="input-2026"
                      placeholder="ברירת מחדל: שם הפרשה"
                    />
                  </div>
                </div>
                <small class="form-row-2026__hint -mt-1">
                  הפטרה אופציונלי. אם השדה ריק, יוצג שם הפרשה.
                </small>

                <!-- Aliyot — <select> per slot, two sub-columns on sm+ -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-3 gap-y-2 pt-2 border-t border-ink-100">
                  <div class="form-row-2026" *ngFor="let label of aliyotLabels; let i = index">
                    <label class="form-row-2026__label" [attr.for]="'prtAliya' + i">{{ label }}</label>
                    <select
                      [id]="'prtAliya' + i"
                      [(ngModel)]="manualAliyot[i]"
                      class="input-2026"
                    >
                      <option value="">-- בחר מתפלל --</option>
                      <option *ngFor="let u of users" [value]="u.firstName + ' ' + u.lastName">
                        {{ u.firstName }} {{ u.lastName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

            </div>
          </ng-container>
        </div>
      </div>

      <!-- Dialog footer -->
      <div class="px-4 md:px-6 py-4 border-t border-ink-100 bg-bg flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
        <button type="button" (click)="closeDialog()" class="btn-2026--ghost w-full sm:w-auto sm:min-w-[140px]">
          ביטול
        </button>
        <button type="button" (click)="submitSelection()" class="btn-2026--primary w-full sm:w-auto sm:min-w-[200px]">
          המשך
        </button>
      </div>
    </div>
  </div>
</section>
